/**
 * @generated SignedSource<<efbcd2ba2ebb1715113c51df09d0fcd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateMethodOfUseInput = {
  description: string;
};
export type UpdateProcedureInput = {
  description: string;
};
export type UpdateEaseOfUseRatingInput = {
  description: string;
};
export type UpdateAgeGroupInput = {
  beginAge: number;
  endAge: number;
  groupNumber: number;
  groupPercentage: number;
};
export type UpdateJobMutation$variables = {
  ageGroups?: ReadonlyArray<UpdateAgeGroupInput | null> | null;
  childrenIds?: ReadonlyArray<string | null> | null;
  customerId: string;
  customerTest?: string | null;
  description?: string | null;
  disclaimer?: string | null;
  easeOfUseRatings?: ReadonlyArray<UpdateEaseOfUseRatingInput | null> | null;
  endDate?: any | null;
  id: string;
  jobCategoryId: string;
  key: string;
  maxParticipantsPerProctor?: number | null;
  maxParticipantsPerSite?: number | null;
  methodsOfUse?: ReadonlyArray<UpdateMethodOfUseInput | null> | null;
  notes?: string | null;
  numberOfParticipants?: number | null;
  objectives?: string | null;
  otherInfo?: string | null;
  parentId?: string | null;
  participantType?: string | null;
  preparedById: string;
  procedureNotes?: string | null;
  procedures?: ReadonlyArray<UpdateProcedureInput | null> | null;
  regionIds: ReadonlyArray<string>;
  reportHistory?: string | null;
  reportTree?: number | null;
  requiredParticipants?: number | null;
  requiredTorque?: number | null;
  resultsDiscussion?: string | null;
  samplePicture?: string | null;
  sampleType?: string | null;
  status: string;
  submitter?: string | null;
  testDescription?: string | null;
  testObjectId?: string | null;
  testType?: string | null;
};
export type UpdateJobMutation$data = {
  readonly updateJob: {
    readonly id: string;
  } | null;
};
export type UpdateJobMutation = {
  response: UpdateJobMutation$data;
  variables: UpdateJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ageGroups"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "childrenIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerTest"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disclaimer"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "easeOfUseRatings"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jobCategoryId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxParticipantsPerProctor"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxParticipantsPerSite"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "methodsOfUse"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notes"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfParticipants"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectives"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherInfo"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participantType"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "preparedById"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "procedureNotes"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "procedures"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionIds"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportHistory"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportTree"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredParticipants"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredTorque"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resultsDiscussion"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "samplePicture"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sampleType"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "submitter"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "testDescription"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "testObjectId"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "testType"
},
v36 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "ageGroups",
            "variableName": "ageGroups"
          },
          {
            "kind": "Variable",
            "name": "childrenIds",
            "variableName": "childrenIds"
          },
          {
            "kind": "Variable",
            "name": "customerId",
            "variableName": "customerId"
          },
          {
            "kind": "Variable",
            "name": "customerTest",
            "variableName": "customerTest"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "disclaimer",
            "variableName": "disclaimer"
          },
          {
            "kind": "Variable",
            "name": "easeOfUseRatings",
            "variableName": "easeOfUseRatings"
          },
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "endDate"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "jobCategoryId",
            "variableName": "jobCategoryId"
          },
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
          },
          {
            "kind": "Variable",
            "name": "maxParticipantsPerProctor",
            "variableName": "maxParticipantsPerProctor"
          },
          {
            "kind": "Variable",
            "name": "maxParticipantsPerSite",
            "variableName": "maxParticipantsPerSite"
          },
          {
            "kind": "Variable",
            "name": "methodsOfUse",
            "variableName": "methodsOfUse"
          },
          {
            "kind": "Variable",
            "name": "notes",
            "variableName": "notes"
          },
          {
            "kind": "Variable",
            "name": "numberOfParticipants",
            "variableName": "numberOfParticipants"
          },
          {
            "kind": "Variable",
            "name": "objectives",
            "variableName": "objectives"
          },
          {
            "kind": "Variable",
            "name": "otherInfo",
            "variableName": "otherInfo"
          },
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          },
          {
            "kind": "Variable",
            "name": "participantType",
            "variableName": "participantType"
          },
          {
            "kind": "Variable",
            "name": "preparedById",
            "variableName": "preparedById"
          },
          {
            "kind": "Variable",
            "name": "procedureNotes",
            "variableName": "procedureNotes"
          },
          {
            "kind": "Variable",
            "name": "procedures",
            "variableName": "procedures"
          },
          {
            "kind": "Variable",
            "name": "regionIds",
            "variableName": "regionIds"
          },
          {
            "kind": "Variable",
            "name": "reportHistory",
            "variableName": "reportHistory"
          },
          {
            "kind": "Variable",
            "name": "reportTree",
            "variableName": "reportTree"
          },
          {
            "kind": "Variable",
            "name": "requiredParticipants",
            "variableName": "requiredParticipants"
          },
          {
            "kind": "Variable",
            "name": "requiredTorque",
            "variableName": "requiredTorque"
          },
          {
            "kind": "Variable",
            "name": "resultsDiscussion",
            "variableName": "resultsDiscussion"
          },
          {
            "kind": "Variable",
            "name": "samplePicture",
            "variableName": "samplePicture"
          },
          {
            "kind": "Variable",
            "name": "sampleType",
            "variableName": "sampleType"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "submitter",
            "variableName": "submitter"
          },
          {
            "kind": "Variable",
            "name": "testDescription",
            "variableName": "testDescription"
          },
          {
            "kind": "Variable",
            "name": "testObjectId",
            "variableName": "testObjectId"
          },
          {
            "kind": "Variable",
            "name": "testType",
            "variableName": "testType"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Job",
    "kind": "LinkedField",
    "name": "updateJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateJobMutation",
    "selections": (v36/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v14/*: any*/),
      (v9/*: any*/),
      (v20/*: any*/),
      (v23/*: any*/),
      (v31/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v32/*: any*/),
      (v35/*: any*/),
      (v19/*: any*/),
      (v26/*: any*/),
      (v15/*: any*/),
      (v12/*: any*/),
      (v11/*: any*/),
      (v3/*: any*/),
      (v25/*: any*/),
      (v34/*: any*/),
      (v27/*: any*/),
      (v5/*: any*/),
      (v17/*: any*/),
      (v24/*: any*/),
      (v33/*: any*/),
      (v16/*: any*/),
      (v21/*: any*/),
      (v28/*: any*/),
      (v7/*: any*/),
      (v13/*: any*/),
      (v22/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v18/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateJobMutation",
    "selections": (v36/*: any*/)
  },
  "params": {
    "cacheID": "9bc2d722aa8cabe51b3bbc9bb8e7f6ba",
    "id": null,
    "metadata": {},
    "name": "UpdateJobMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateJobMutation(\n  $id: ID!\n  $key: String!\n  $customerId: ID!\n  $description: String\n  $notes: String\n  $jobCategoryId: ID!\n  $preparedById: ID!\n  $regionIds: [ID!]!\n  $status: String!\n  $samplePicture: String\n  $sampleType: String\n  $submitter: String\n  $testType: String\n  $participantType: String\n  $requiredParticipants: Int\n  $numberOfParticipants: Int\n  $maxParticipantsPerSite: Int\n  $maxParticipantsPerProctor: Int\n  $customerTest: String\n  $reportTree: Int\n  $testObjectId: ID\n  $requiredTorque: Int\n  $disclaimer: String\n  $otherInfo: String\n  $reportHistory: String\n  $testDescription: String\n  $objectives: String\n  $procedureNotes: String\n  $resultsDiscussion: String\n  $endDate: DateTime\n  $methodsOfUse: [UpdateMethodOfUseInput]\n  $procedures: [UpdateProcedureInput]\n  $easeOfUseRatings: [UpdateEaseOfUseRatingInput]\n  $ageGroups: [UpdateAgeGroupInput]\n  $parentId: ID\n  $childrenIds: [ID]\n) {\n  updateJob(input: {id: $id, key: $key, customerId: $customerId, description: $description, notes: $notes, jobCategoryId: $jobCategoryId, preparedById: $preparedById, regionIds: $regionIds, status: $status, samplePicture: $samplePicture, sampleType: $sampleType, submitter: $submitter, testType: $testType, participantType: $participantType, requiredParticipants: $requiredParticipants, numberOfParticipants: $numberOfParticipants, maxParticipantsPerSite: $maxParticipantsPerSite, maxParticipantsPerProctor: $maxParticipantsPerProctor, customerTest: $customerTest, reportTree: $reportTree, testObjectId: $testObjectId, requiredTorque: $requiredTorque, disclaimer: $disclaimer, otherInfo: $otherInfo, reportHistory: $reportHistory, testDescription: $testDescription, objectives: $objectives, procedureNotes: $procedureNotes, resultsDiscussion: $resultsDiscussion, methodsOfUse: $methodsOfUse, procedures: $procedures, easeOfUseRatings: $easeOfUseRatings, ageGroups: $ageGroups, parentId: $parentId, childrenIds: $childrenIds, endDate: $endDate}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0584a204f714da6e331614d7dc3bf9c";

export default node;
